import { UILightColor } from '@kite-js/theme-types';

const lightScale: UILightColor = {
    20: '#f3f4f4',
    50: '#e8e8e9',
    100: '#dddedf',
    150: '#d2d3d4',
    200: '#a5a6a9',
    300: '#777a7f',
    500: '#4a4d54',
    800: '#1d2129',
};

export default lightScale;
